import GithubLogo from './GithubLogo';

export default GithubLogo;
